<div class="navbar sidemenu">

  <!-- Mobile Menu -->
  <!-- <div class="mobile-menu">
    <button
      type="button"
      class="menu-toggle"
      (click)="toggleSideMenu()"
      aria-label="Toggle navigation"
      [attr.aria-expanded]="false"
    >
      <i class="fa-solid fa-bars"></i>
    </button>
  </div> -->

  <!-- Page Header Content -->
  <div class="header-content">
    <div class="page-header-contents">
      <ng-content></ng-content>
    </div>
  </div>

</div>
